module.exports = __webpack_public_path__ + "media/public/images/icon-plus-b693a2c362da3e134de13b29c3077cc7.svg";